export default "__VITE_ASSET__348fd361__"